// @flow
import * as React from 'react';
import {connect} from 'react-redux';

import IndicationMessage from './indication-message.block.js';
import {setMessages} from "./ui.actions";
import type { Messages } from "./ui.types";

type Props = {
  messages: Messages,
  className?: string,
  closable?: boolean,
  setMessages: typeof setMessages
};

class Indication extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.handleMessageClose = this.handleMessageClose.bind(this);
  }

  handleMessageClose(e: SyntheticMouseEvent<HTMLInputElement>) {
    const {key} = e.currentTarget.dataset;
    const {messages} = this.props;
    const nextMessages = messages.filter(msg => msg.key !== key);
    return this.props.setMessages(nextMessages);
  }

  render() {
    const {messages, closable = false, className} = this.props;
    const messageIds = messages.map(message => message.text);
    const filteredMessages = messages
      .filter(({text}, index) => messageIds.indexOf(text) === index);

    if (!messages.length) return null;

    return (
      <div className={`indication-group ${className || ''}`}>
        {filteredMessages.map(message => (
          <IndicationMessage
            key={message.key}
            message={message}
            messageKey={message.key}
            closable={closable}
            onClose={this.handleMessageClose}
          />
        ))}
      </div>
    );
  }
}

export default connect(
  null,
  { setMessages }
)(Indication);
